export enum Status {
	Idle = 'idle',
	Saving = 'saving',
	Deleting = 'deleting',
	Loading = 'loading',
}
